import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import { Dialog } from '../../components';
import { deleteMessage } from '../../mutations';

export class MessageDelete extends Component {
  state = {
    showDialog: false,
  };

  handleShowDialog = () => this.setState({ showDialog: true });

  handleCancelDeletion = () => this.hideDialog();

  handleConfirmDeletion = () => {
    this.hideDialog();

    const { message, lists, relay, history } = this.props;

    deleteMessage(relay.environment, message.id, lists.id, {
      onCompleted: () => history.push('/messages/tab/active'),
    });
  };

  hideDialog = () => this.setState({ showDialog: false });

  render() {
    return (
      <React.Fragment>
        <div
          id="deleteMessage"
          className="button delete"
          onClick={this.handleShowDialog}
        >
          Delete
        </div>
        <Dialog
          className="deletion"
          isOpen={this.state.showDialog}
          message="This will delete the message and remove it from the message list. Are you sure you want to proceed?"
          onConfirm={this.handleConfirmDeletion}
          onCancel={this.handleCancelDeletion}
        />
      </React.Fragment>
    );
  }
}

export default createFragmentContainer(MessageDelete, {
  message: graphql`
    fragment MessageDelete_message on Message {
      id
    }
  `,
  lists: graphql`
    fragment MessageDelete_lists on Lists {
      id
    }
  `,
});
